var map = {
	"./ACGIH-Heavy": 423,
	"./ACGIH-Heavy.json": 423,
	"./ACGIH-Light": 424,
	"./ACGIH-Light.json": 424,
	"./ACGIH-Moderate": 425,
	"./ACGIH-Moderate.json": 425,
	"./ACSM-Acclimatized": 426,
	"./ACSM-Acclimatized.json": 426,
	"./ACSM-NonAcclimatized": 427,
	"./ACSM-NonAcclimatized.json": 427,
	"./GaStateHighSchool": 428,
	"./GaStateHighSchool.json": 428,
	"./KyStateHighSchool": 429,
	"./KyStateHighSchool.json": 429,
	"./NATA": 430,
	"./NATA.json": 430,
	"./NcStateHighSchool": 431,
	"./NcStateHighSchool.json": 431,
	"./NjStateHighSchool": 432,
	"./NjStateHighSchool.json": 432,
	"./TBMed507-Easy": 433,
	"./TBMed507-Easy.json": 433,
	"./TBMed507-Hard": 434,
	"./TBMed507-Hard.json": 434,
	"./TBMed507-Moderate": 435,
	"./TBMed507-Moderate.json": 435,
	"./UsaSoccer-Cat1": 436,
	"./UsaSoccer-Cat1.json": 436,
	"./UsaSoccer-Cat2": 437,
	"./UsaSoccer-Cat2.json": 437,
	"./UsaSoccer-Cat3": 438,
	"./UsaSoccer-Cat3.json": 438,
	"./VtStateHighSchool": 439,
	"./VtStateHighSchool.json": 439,
	"./_HeatStressGuidelinesIndex": 327,
	"./_HeatStressGuidelinesIndex.json": 327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;